import { observable, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import {Segment} from 'main/stores/segmentation';

class VisibilitySetting extends DomainObject {
  settingType;
  enabled;
  segment;

  _relations = {
    segment: Segment
  };

  constructor(other) {
    super();

    makeObservable(this, {
      settingType: observable,
      enabled: observable,
      segment: observable
    });

    this.merge(other);
  }
}

export default VisibilitySetting;
